import React from 'react'
import { useSelector } from 'react-redux'
import { IconArrowDown, IconArrowUp } from '@tabler/icons-react'

import { Pill } from '@/components/pills/Pill'
import { getSelectedAgent } from '@/reducers/voiceAgents/voiceAgents.helpers'

// Read-only display of an agent's call direction. Accepts a `direction` prop
// for per-row rendering (e.g. the list page); falls back to the selected-agent
// selector for the detail header so existing callers stay drop-in.
//
// `size` is passed straight through to Pill ('xs' | 'small' | 'large'). The list
// page's cards use 'xs' so the pill reads as metadata in the card footer rather
// than competing with the agent's name; callers that omit it keep the default.
const DirectionPill = ({ direction: directionProp, size }) => {
  const selectedAgent = useSelector((state) => getSelectedAgent(state.voiceAgents))
  const direction = directionProp ?? selectedAgent?.direction
  if (!direction) {
    return null
  }

  const isInbound = direction === 'inbound'
  const Icon = isInbound ? IconArrowDown : IconArrowUp
  const label = isInbound ? 'Inbound' : 'Outbound'

  // Single outlined recipe regardless of direction — the icon (arrow down
  // vs up) + the label already convey direction. Matches the design mock's
  // white-bg / light-border / capsule chip used on the Call Start card.
  return (
    <Pill outlined size={size} icon={<Icon />} data-testid="direction-pill">
      {label}
    </Pill>
  )
}

export default DirectionPill
